document.addEventListener('DOMContentLoaded', () => {
  console.log('Custom Header JS: DOMContentLoaded fired.'); // Log script start

  // Remove loading class to reveal header
  const headerElement = document.getElementById('site-header');
  if (headerElement) {
    headerElement.classList.remove('header-loading'); // Just remove display:none
    console.log('Custom Header JS: Removed header-loading class.');
  } else {
    console.error('Custom Header JS: Could not find header element #site-header.');
  }

  const searchTrigger = document.getElementById('mobile-search-trigger');
  const searchContainer = document.getElementById('mobile-search-container');
  const searchInput = searchContainer ? searchContainer.querySelector('input[type="search"]') : null;

  console.log('Custom Header JS: Trigger found?', searchTrigger); // Log trigger element
  console.log('Custom Header JS: Container found?', searchContainer); // Log container element

  if (searchTrigger && searchContainer) {
    console.log('Custom Header JS: Attaching click listener to trigger.'); // Log listener attachment
    searchTrigger.addEventListener('click', (event) => {
      // event.stopPropagation(); // Optional: Uncomment if clicks seem to be bubbling unexpectedly
      console.log('Custom Header JS: Search trigger clicked!'); // Log click event

      const isExpanded = searchTrigger.getAttribute('aria-expanded') === 'true';
      
      // Toggle class and ARIA attribute
      searchContainer.classList.toggle('is-active');
      searchTrigger.setAttribute('aria-expanded', !isExpanded);
      console.log('Custom Header JS: Toggled active class. New expanded state:', !isExpanded); // Log toggle action

      // Optional: Focus the input when opening
      if (!isExpanded && searchInput) {
        console.log('Custom Header JS: Attempting to focus input.'); // Log focus attempt
        // Use a small timeout to ensure the element is visible and focusable
        setTimeout(() => {
          searchInput.focus();
          console.log('Custom Header JS: Input focus executed.'); // Log focus execution
        }, 50); 
      }
    });

    // Optional: Close search if clicking outside the container
    document.addEventListener('click', (event) => {
      // Check if the click is outside the trigger and the container AND the container is active
      if (searchContainer.classList.contains('is-active') && 
          !searchTrigger.contains(event.target) && 
          !searchContainer.contains(event.target)) {
            
        console.log('Custom Header JS: Click outside detected, closing search.'); // Log outside click close
        searchContainer.classList.remove('is-active');
        searchTrigger.setAttribute('aria-expanded', 'false');
      }
    });

  } else {
    console.error('Custom Header JS: Could not find trigger or container element.'); // Log if elements not found
  }
});
